/**************************************************
 * Nombre:       Seccion_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import Tarjeta_Pedidos_Realizados from "../Tarjetas/Tarjeta_Pedidos_Realizados";
import {obtenerObjLocal} from "../../Servicios/BDLocal/obtenerObjLocal";
import img_def from "../../Recursos/img_cat_defecto.png";
import Marcas_Home from "../Componentes/Home/Marcas_Home";
import Preguntas_Home from "../Componentes/Home/Preguntas_Home";
import Puntos_Home from "../Componentes/Home/Puntos_Home";
import Creamos_Home from "../Componentes/Home/Creamos_Home";
import Footer from "../Footer";
import {irArriba} from "../../Utilidades/irArriba";
import {guardarObjLocal} from "../../Servicios/BDLocal/guardarObjLocal";

const Seccion_Mis_Compras = () => {
    const {masSM, sCell} = useResponsive()
    const [pedidos, setPedidos] = useState([])


    const borrar = () => {

        guardarObjLocal({key: 'pedidos', obj: []})
        setPedidos([])
    }

    useEffect(() => {

        irArriba()

        let peds = obtenerObjLocal({key: 'pedidos'})
        if (peds) {
            setPedidos(peds.sort(function (a, b) {
                return b.fecha - a.fecha;
            }))
        }
    }, []);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}

        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 1 : 3}}
            >


                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{maxWidth: '1400px', px: 0.5}}
                        spacing={3}
                    >


                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}} sx={{mt: 3}}>

                            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{pl: 1}}>
                                <Typography sx={{fontSize: 20, fontWeight: 600, color: '#4C4C4C'}}>
                    <span><img src={img_def} width={30}
                               height={'auto'}
                               style={{marginBottom: -6, marginRight: 6}}/></span>
                                    Pedidos realizados desde este dispositivo</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-end'}}>
                                <Button
                                    onClick={() => borrar()}
                                    variant={'outlined'}>Borrar pedidos</Button>
                            </Grid>

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}} sx={{mt: 1}}>


                                {pedidos.map((item, index) => (
                                    <Grid item size={12} key={`${index}da`}
                                          sx={{mt: -1}}>
                                        <Tarjeta_Pedidos_Realizados
                                            item={item}
                                        />
                                    </Grid>
                                ))}

                            </Grid>


                        </Grid>


                    </Grid>


                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 6}}>
                    <Marcas_Home/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 18}}>
                    <Preguntas_Home/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 18}}>
                    <Puntos_Home/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 18}}>
                    <Creamos_Home/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 18}}>
                    <Footer/>
                </Grid>


            </Grid>


        </Grid>
    );

}
export default Seccion_Mis_Compras